import React from "react";
import { useEffect, useRef } from "react";

const BasketUpsellBlock = (props) => {

    if (!Object.values(props.content).some(value => Boolean(value))) return null;

    const upsaleTitleRef = useRef();

    useEffect(() => {
        window.upsaleTitleH3 = upsaleTitleRef.current;
    }, []);


    const membershipID =
        props.content.id && props.content.id.innerHTML
            ? props.content.id.innerHTML
            : '';

    return (
        <>
            <div className="membership-upsale" data-custom-block-container data-membership-id={membershipID}>
                {props.content.title?.innerHTML &&
                    <h3 ref={upsaleTitleRef} dangerouslySetInnerHTML={{ __html: props.content.title.innerHTML }} data-upsale-title></h3>
                }
                {props.content.introduction?.innerHTML &&
                    <div dangerouslySetInnerHTML={{ __html: props.content.introduction.innerHTML }}></div>
                }
                {props.content.button?.innerHTML &&
                    <button
                        className='btn btn--icon white'
                        data-add-membership
                        dangerouslySetInnerHTML={{ __html: props.content.button.innerHTML }}
                    ></button>
                }
            </div>

            <div className="membership-upsale" data-thank-you-membership style={{ display: 'none' }}>
                {props.content.Thankstitle?.innerHTML &&
                    <h3 dangerouslySetInnerHTML={{ __html: props.content.Thankstitle.innerHTML }}></h3>
                }
                {props.content.Thanksintroduction?.innerHTML &&
                    <div dangerouslySetInnerHTML={{ __html: props.content.Thanksintroduction.innerHTML }}></div>
                }
            </div>
        </>
    );
};

export default BasketUpsellBlock;
